import axios from 'axios';

const DefaultPageSize = 10;

export default {
  search(teamId, eventId, term) {
    return axios
      .post('/api/eventFileSystemObject.search', {
        params: {
          teamId,
          eventId,
        },
        query: {
          term,
        },
      })
      .then((result) => result.data);
  },

  updateFolder(
    teamId,
    eventId,
    parentPath,
    existingName,
    newName,
    newDescription,
  ) {
    return axios
      .post('/api/eventFileSystemObject.updateFolder', {
        params: {
          teamId,
          eventId,
        },
        payload: {
          parentPath,
          existingName,
          newName,
          newDescription,
        },
      })
      .then((result) => result.data);
  },

  move(teamId, eventId, fsObjectId, parentId) {
    let method = parentId
      ? '/api/eventFileSystemObject.move'
      : '/api/eventFileSystemObject.moveToRoot';

    return axios
      .post(method, {
        params: {
          teamId,
          eventId,
          id: fsObjectId,
          parentId,
        },
      })
      .then((result) => result.data);
  },

  get(teamId, eventId, id) {
    return axios
      .post('/api/eventFileSystemObject.get', {
        params: {
          teamId,
          eventId,
          objectId: id,
        },
      })
      .then((result) => result.data);
  },

  getByPath(teamId, eventId, parentPath, name) {
    let query = {
      name,
    };

    if (parentPath) {
      query.parentPath = parentPath;
    }

    return axios
      .post('/api/eventFileSystemObject.getByPath', {
        params: {
          teamId,
          eventId,
        },
        query,
      })
      .then((result) => result.data);
  },

  getFolderChildren(
    teamId,
    eventId,
    pageNumber,
    pageSize,
    parentId,
    sortBy,
    sortDirection,
  ) {
    let query = {
      page: pageNumber,
      size: pageSize || DefaultPageSize,
      parentId,
      sortBy,
      sortDirection,
    };

    return axios
      .post('/api/eventFileSystemObject.getChildren', {
        query,
        params: {
          teamId,
          eventId,
        },
      })
      .then((result) => result.data);
  },

  getFolders(teamId, eventId, parentId) {
    let query = {
      page: 1,
      size: 200,
      directories: 'true',
      parentId,
    };

    return axios
      .post('/api/eventFileSystemObject.getChildren', {
        query,
        params: {
          teamId,
          eventId,
        },
      })
      .then((result) => result.data);
  },

  createFolder(teamId, eventId, fsObject) {
    return axios
      .post('/api/eventFileSystemObject.createFolder', {
        params: {
          teamId,
          eventId,
        },
        payload: fsObject,
      })
      .then((result) => result.data);
  },

  archive(teamId, eventId, objectId) {
    return axios
      .post('/api/eventFileSystemObject.archive', {
        params: {
          teamId,
          eventId,
          objectId,
        },
      })
      .then((result) => result.data);
  },

  restoreArchive(teamId, eventId, objectId) {
    return axios
      .post('/api/eventFileSystemObject.restoreArchive', {
        params: {
          teamId,
          eventId,
          objectId,
        },
      })
      .then((result) => result.data);
  },

  getImplicitlyArchived(teamId, eventId, parentId) {
    return axios
      .post('/api/eventFileSystemObject.getImplicitlyArchived', {
        params: {
          teamId,
          eventId,
          parentId,
        },
      })
      .then((result) => result.data);
  },

  softDelete(teamId, eventId, eventFileSystemObjectId) {
    return axios
      .post('/api/eventFileSystemObject.softDelete', {
        params: {
          teamId,
          eventId,
          eventFileSystemObjectId,
        },
      })
      .then((result) => result.data);
  },

  getByDisplayType(
    teamId,
    eventId,
    displayType,
    pageNumber,
    pageSize,
    sortBy,
    sortDirection,
  ) {
    let query = {
      page: pageNumber,
      size: pageSize || DefaultPageSize,
      sortBy,
      sortDirection,
    };

    return axios
      .post('/api/eventFileSystemObject.getByDisplayType', {
        params: {
          teamId,
          eventId,
          displayType,
        },
        query,
      })
      .then((result) => result.data);
  },
};
